export const zh = {
  dashboard: '仪表板',
  location: '位置信息',
  photos: '照片列表',
  history: '日记历史',
  settings: '设置',
  connected: '已连接',
  connecting: '连接中',
  disconnected: '未连接',
  error: '错误',
  reconnect: '重新连接',
  photoData: '照片数据',
  audioData: '音频数据',
  gpsData: 'GPS数据',
  realtimeData: '实时数据',
  waitingForData: '等待数据中...',
  gpsDataList: 'GPS数据列表',
  waitingForGps: '等待GPS数据中...',
  diaryHistory: '日记历史',
  underDevelopment: '功能开发中'
};